<template>
    <div class="main">
        <c-panel title="GRADE PADRÃO (MATRIZ CURRICULAR)" titleIcon="fas fa-th-list">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Monte a grade de disciplinas por Série (padrão) ou por Turma. Para cada disciplina defina a ordem no boletim, a carga horária anual e, opcionalmente, o Grupo de Conceito (como avalia) e o Grupo de Conteúdo (o que trabalha)."></el-alert>

            <!-- ESCOPO -->
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="5">
                        <el-form-item label="Escopo">
                            <el-select v-model="escopo" @change="onChangeEscopo" style="width:100%;">
                                <el-option label="Por Série (curso)" value="curso"></el-option>
                                <el-option label="Por Turma" value="turma"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- SÉRIE -->
                    <el-col :xs="24" :sm="12" :md="12" v-if="escopo === 'curso'">
                        <el-form-item label="Série (Curso)">
                            <el-select v-model="cursoId" filterable clearable placeholder="Selecione a série" @change="carregarGrade" style="width:100%;">
                                <el-option v-for="c in cursos" :key="c.id" :label="c.nome" :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- TURMA -->
                    <template v-if="escopo === 'turma'">
                        <el-col :xs="24" :sm="6" :md="6" v-if="ehSmed">
                            <el-form-item label="Instituição">
                                <el-select v-model="instituicaoId" filterable clearable placeholder="Selecione" @change="onChangeInstituicao" style="width:100%;">
                                    <el-option v-for="(i, k) in $store.state.instituicoes" :key="k" :label="i.nome" :value="i.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Turma">
                                <el-select v-model="turmaId" filterable clearable placeholder="Selecione a turma" @change="onChangeTurma" style="width:100%;">
                                    <el-option-group v-for="(grupo, g) in turmas" :key="g" :label="g">
                                        <el-option v-for="t in grupo" :key="t.id" :label="`${t.curso.nome} ${t.nome}`" :value="t.id"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </template>
                </el-row>
            </el-form>

            <!-- GRADE -->
            <div v-if="escopoIdAtual">
                <el-row class="u-mb-10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button v-if="escopo === 'turma' && turmaCursoId" size="small" type="warning" plain icon="el-icon-download" @click="aplicarGradeSerie">
                            APLICAR GRADE DA SÉRIE
                        </el-button>
                        <el-button size="small" type="primary" plain icon="el-icon-plus" @click="adicionarLinha">ADICIONAR DISCIPLINA</el-button>
                    </el-col>
                </el-row>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width:60px;" class="u-text-center">Ordem</th>
                                <th style="width:26%;">Disciplina</th>
                                <th style="width:110px;" class="u-text-center">Carga h/ano</th>
                                <th>Conceito (escala)</th>
                                <th>Grupo de Conteúdo</th>
                                <th style="width:60px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(l, i) in linhas" :key="i">
                                <td class="u-text-center">
                                    <el-input-number v-model="l.ordem_boletim" :min="0" :controls="false" size="mini" style="width:52px;"></el-input-number>
                                </td>
                                <td>
                                    <el-select v-model="l.disciplina_id" filterable placeholder="Selecione" size="small" style="width:100%;">
                                        <el-option v-for="d in disciplinas" :key="d.id" :label="d.nome_area" :value="d.id"></el-option>
                                    </el-select>
                                </td>
                                <td class="u-text-center">
                                    <el-input-number v-model="l.qtd_aulas_anual" :min="0" :controls="false" size="mini" style="width:90px;"></el-input-number>
                                </td>
                                <td>
                                    <el-select v-model="l.conceito_id" filterable clearable placeholder="(nenhum)" size="small" style="width:100%;">
                                        <el-option v-for="c in conceitos" :key="c.id" :label="c.descricao" :value="c.id"></el-option>
                                    </el-select>
                                </td>
                                <td>
                                    <el-select v-model="l.grupo_conteudo_id" filterable clearable placeholder="(nenhum)" size="small" style="width:100%;">
                                        <el-option v-for="g in gruposConteudo" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                                    </el-select>
                                </td>
                                <td class="u-text-center">
                                    <el-button type="danger" size="mini" plain icon="el-icon-delete" @click="removerLinha(i)"></el-button>
                                </td>
                            </tr>
                            <tr v-if="!linhas.length">
                                <td colspan="6" class="u-text-center" style="padding:18px; color:#909399;">
                                    Nenhuma disciplina na grade. Clique em "ADICIONAR DISCIPLINA".
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="success" icon="el-icon-check" @click="salvar">SALVAR GRADE</el-button>
                    </el-col>
                </el-row>
            </div>

            <div v-else class="u-text-center" style="color:#909399; padding:30px;">
                Selecione o escopo e o item (série ou turma) para montar a grade.
            </div>

        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return {
            escopo: 'curso',
            cursos: [],
            cursoId: null,
            instituicaoId: null,
            turmas: [],
            turmaId: null,
            turmaCursoId: null,
            disciplinas: [],
            conceitos: [],
            gruposConteudo: [],
            linhas: []
        }
    },
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        periodoLetivoId () { return this.$store.state.config.parametros.periodo_letivo_situacao_academica },
        escopoIdAtual () { return this.escopo === 'curso' ? this.cursoId : this.turmaId }
    },
    mounted () {
        this.carregarInitForm()
        this.carregarCursos()
        if (!this.ehSmed) { this.instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        carregarInitForm () {
            this.$axios.get(`${this.baseUrl()}/api/grade-padrao/initForm`, this.$store.getters.getHeaderAuth).then(r => {
                this.disciplinas = (r.data && r.data.disciplinas) || []
                this.conceitos = (r.data && r.data.conceitos) || []
                this.gruposConteudo = (r.data && r.data.gruposConteudo) || []
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregarCursos () {
            this.$axios.get(`${this.baseUrl()}/api/curso/getAllCurso`, this.$store.getters.getHeaderAuth)
                .then(r => { this.cursos = r.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarTurmas () {
            this.turmas = []
            if (!this.instituicaoId || !this.periodoLetivoId) return
            this.$axios.get(`${this.baseUrl()}/api/turma/getTurmasForListDiario/${this.instituicaoId}/${this.periodoLetivoId}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.turmas = r.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        onChangeEscopo () {
            this.cursoId = null
            this.turmaId = null
            this.turmaCursoId = null
            this.linhas = []
            if (this.escopo === 'turma') this.carregarTurmas()
        },
        onChangeInstituicao () {
            this.turmaId = null
            this.turmaCursoId = null
            this.linhas = []
            this.carregarTurmas()
        },
        onChangeTurma () {
            this.turmaCursoId = null
            for (const g in this.turmas) {
                for (const t of this.turmas[g]) {
                    if (t.id === this.turmaId) { this.turmaCursoId = t.curso ? t.curso.id : null }
                }
            }
            this.carregarGrade()
        },
        carregarGrade () {
            this.linhas = []
            if (!this.escopoIdAtual) return
            this.$axios.get(`${this.baseUrl()}/api/grade-padrao/getPorEscopo/${this.escopo}/${this.escopoIdAtual}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    const dados = Array.isArray(r.data) ? r.data : []
                    this.linhas = dados.map(d => ({
                        disciplina_id: d.disciplina_id,
                        ordem_boletim: d.ordem_boletim,
                        qtd_aulas_anual: d.qtd_aulas_anual,
                        conceito_id: d.conceito_id,
                        grupo_conteudo_id: d.grupo_conteudo_id
                    }))
                }).catch(e => this.$store.commit('throwException', e))
        },
        adicionarLinha () {
            this.linhas.push({
                disciplina_id: null,
                ordem_boletim: this.linhas.length + 1,
                qtd_aulas_anual: 0,
                conceito_id: null,
                grupo_conteudo_id: null
            })
        },
        removerLinha (i) { this.linhas.splice(i, 1) },
        salvar () {
            const semDisciplina = this.linhas.some(l => !l.disciplina_id)
            if (this.linhas.length && semDisciplina) {
                window.eventBus.$emit('alert', { msg: 'Há linhas sem disciplina selecionada.', type: 'warning' })
                return
            }
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.baseUrl()}/api/grade-padrao/salvarLote`,
                { escopo: this.escopo, id: this.escopoIdAtual, itens: this.linhas },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Grade salva com sucesso.', type: 'success' })
                this.carregarGrade()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        aplicarGradeSerie () {
            if (!this.turmaCursoId) {
                window.eventBus.$emit('alert', { msg: 'Não foi possível identificar a série da turma.', type: 'warning' })
                return
            }
            this.$confirm('Isto copia a grade da série para esta turma (não sobrescreve se a turma já tiver grade). Continuar?', 'Aplicar grade da série', { type: 'warning' }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.baseUrl()}/api/grade-padrao/materializarParaTurma`,
                    { curso_id: this.turmaCursoId, turma_id: this.turmaId },
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: r.data.mensagem || 'Grade aplicada.', type: 'success' })
                    this.carregarGrade()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        }
    }
}
</script>
